import { create } from "zustand";
import { ManageAsesmenStore } from "./manage-asesmen";
import { DefaultIndexParams, SearchPsikologParams } from "../../types/common";
import {
  getLocations,
  getPsikologRegions,
  getRegions,
} from "./manage-asesmen.service";

export const useManageAsesmenStore = create<ManageAsesmenStore>((set, get) => ({
  regions: null,
  locations: null,
  psikologs: null,

  loadingLocations: false,
  loadingRegions: false,
  loadingPsikologs: false,

  getLocations: async (params?: DefaultIndexParams) => {
    set({ loadingLocations: true });
    try {
      const data = await getLocations(params);
      set({
        locations: data.data,
      });
    } catch (error) {
    } finally {
      set({ loadingLocations: false });
    }
  },
  getRegions: async (params?: DefaultIndexParams) => {
    set({ loadingRegions: true });
    try {
      const data = await getRegions(params);
      set({
        regions: data.data,
      });
    } catch (error) {
    } finally {
      set({ loadingRegions: false });
    }
  },

  getPsikologs: async (params?: SearchPsikologParams) => {
    set({ loadingPsikologs: true });
    try {
      const data = await getPsikologRegions(params);
      set({
        psikologs: data.data,
      });
    } catch (error) {
    } finally {
      set({ loadingPsikologs: false });
    }
  },
}));
